/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { getAllQuestions } from "@/lib/services/questions";
import { useQuery } from "@tanstack/react-query";
import ChecklistTable from "./components/checklist-table/ChecklistTable";
import type { QuestionFormType } from "@/types/types";
import { useEffect, useState, useMemo } from "react";
import { useLoader } from "@/context/loader-context/LoaderContext";
import { appToast } from "@/lib/toast";
import Pagination from "../inspections/components/inspections-lists/Pagination/Pagination";

const ChecklistView = () => {
  const [page, setPage] = useState(0);
  const translate = useTranslate();
  const { showLoader, hideLoader } = useLoader();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["checklists", { page }],
    queryFn: () => getAllQuestions({ page: page }),
  });

  useEffect(() => {
    if (isError) {
      appToast.error(translate("error"), error.message);
    }
  }, [isError, error]);

  useEffect(() => {
    if (isLoading) {
      showLoader();
    } else {
      hideLoader();
    }

    return () => {
      hideLoader();
    };
  }, [isLoading]);

  const tablePAgination = useMemo(() => {
    if (!data?.totalPages || data.totalPages < 2) return <></>;
    return (
      <Pagination
        lastPage={data.totalPages}
        initialPage={page}
        changePage={setPage}
      />
    );
  }, [data]);

  return (
    <div
      data-testid="checklist-view"
      className="grid grid-rows-[auto_1fr] h-full min-h-0 max-w-full px-14 pt-12"
    >
      <h1 className="font-ib-bold text-[24px] leading-[150%]">
        {translate("checklist")}
      </h1>
      {data && data.content && (
        <div
          id="scrollable"
          className="min-h-0 overflow-y-auto overflow-x-auto max-w-full pt-8"
        >
          <ChecklistTable
            questionsForms={data.content as QuestionFormType[]}
            pagination={tablePAgination}
          />
        </div>
      )}
    </div>
  );
};

export default ChecklistView;
